import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-toastify";
import auth from "../../firebase.init";
import Loading from "../Shared/Loading";

const ProductDeleteModel = ({
  product,
  refetch,
  setShowProductDeleteModal,
  setModalData,
}) => {
  const [user, userLoading] = useAuthState(auth);
  const { _id, product_name, product_brand_slug } = product;

  if (userLoading) {
    return <Loading></Loading>;
  }

  const handleDeleteProduct = () => {
    fetch(`https://evening-peak-35730.herokuapp.com/product/${_id}`, {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const updateTotalDataStatus = { status: "decreaseProducts" };
        fetch(
          `https://evening-peak-35730.herokuapp.com/updateTotalProductsAndBrands/${user?.email}`,
          {
            method: "PUT",
            headers: {
              "content-type": "application/json",
              authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            body: JSON.stringify(updateTotalDataStatus),
          }
        )
          .then((res2) => {
            return res2.json();
          })
          .then((data2) => {
            setModalData({});
            setShowProductDeleteModal(false);
            refetch();
            toast.success("Product deleted successfully. Alhamdulillah!!");
          });
      });
  };

  return (
    <div>
      <input type="checkbox" id="productDeleteModel" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-xl text-error">
            Are you sure to delete {product_name}!!
          </h3>
          <div className="py-4 font-bold text-primary">
            <p>Brand's Name = {product_name}</p>
            <p>Brand's Slug = {product_brand_slug}</p>
          </div>
          <div className="modal-action">
            <label for="productDeleteModel" className="btn btn-primary">
              No
            </label>
            <label
              onClick={handleDeleteProduct}
              className="btn btn-error text-white font-bold"
            >
              Yes
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDeleteModel;
